export enum CustomerGroup {
  AccessAdmin = 'AccessAdmin',
}
